/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Styles */

const OtpBannerBottomText = ({ sectionContent, pt }) => {
  return (
    <Box maxw={'100%'} bg={'#2A4832'} height={{base:'107px', lg:'84px',}} 
    px={{base: '1rem', md: '0px', lg:'0px'}}
    justifyContent={'center'} display={'flex'} alignItems={'center'}>
      <Box
        as="h2"
        pb="15px"
        w={'100%'}
        textAlign={'center !important'}
      >
        <Text>
          <StructuredTextParser
            color={'#fff'}
            textAlign={'center'}
            className={'h2style'}
            str={render(sectionContent?.body)}
            fontSize={{base: '24px', md: '24px', lg: '24px'}}
            fontWeight={500}
            lineHeight={'30px'}
            fontFamily={'FedraSerifAStdBook'}
          />
        </Text>
      </Box>

      <style jsx global>
        {`
          .h2style h2 {
            font-family: 'FedraSansStd-A-medium', serif;
            font-size: 24px;
            line-height: 30px;
            text-align: center;
          }
          strong {
            color: #FFB30E;
            font-size: 26px;
          }
          @media (max-width: 768px) {
            .h2style h2 {
              font-size: 204px;
            }
            strong {
              font-size: 24px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default OtpBannerBottomText;
